import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../interfaces';
import { Language } from '../../models';
import { LanguageDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { LanguageForm } from './LanguageForm';
import { LoadingIndicator, PVAPage } from '../../components';

export class LanguageEdit extends React.Component<BaseRouteProps<EditProps>, EditState<Language>> {
    private languageDataService = new LanguageDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<EditProps>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.languageDataService.get(id).then((language: Language) => {
                this.setState({ originalEntity: language });
            });
        }
    }

    public render() {
        if (!this.state.originalEntity) {
            return <LoadingIndicator />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/language`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Edit Language
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <LanguageForm defaultValues={this.state.originalEntity} submit={this.save} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.languageDataService.update(values).then((success) => {

            this.props.history.push('/language');
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/language/LanguageEdit.tsx